"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var TizenNetworkStatus = (function (_super) {
    __extends(TizenNetworkStatus, _super);
    function TizenNetworkStatus(window) {
        var _this = _super.call(this) || this;
        _this.network = window.webapis.network;
        _this.network.addNetworkStateChangeListener(function (networkState) {
            var status;
            if (networkState === _this.network.NetworkState.GATEWAY_CONNECTED) {
                status = client_lib_js_player_addons_common_player_1.ConnectionStatus.Connected;
            }
            else {
                status = client_lib_js_player_addons_common_player_1.ConnectionStatus.Disconnected;
            }
            _this.notifyStatusChange(status);
        });
        return _this;
    }
    TizenNetworkStatus.isNetworkSupported = function (window) {
        var network = window.webapis.network;
        if (!network) {
            return false;
        }
        try {
            network.isConnectedToGateway();
            return true;
        }
        catch (e) {
            return false;
        }
    };
    TizenNetworkStatus.prototype.isConnected = function () {
        return this.network.isConnectedToGateway();
    };
    return TizenNetworkStatus;
}(client_lib_js_player_addons_common_player_1.NetworkStatus));
exports.TizenNetworkStatus = TizenNetworkStatus;
